import { Link, useLocation } from 'react-router-dom';

import { localeLabels, localeNames, localStorageLocaleKey } from '../content/shared';
import type { Locale } from '../content/types';
import { getEquivalentPath } from '../lib/routes';

type LanguageSwitcherProps = {
  currentLocale: Locale;
  onNavigate?: () => void;
};

export function LanguageSwitcher({ currentLocale, onNavigate }: LanguageSwitcherProps) {
  const location = useLocation();

  function persistLocale(locale: Locale) {
    window.localStorage.setItem(localStorageLocaleKey, locale);
  }

  return (
    <div className="language-switcher" aria-label="Language switcher">
      {(['en', 'de'] as const).map((locale) => (
        <Link
          key={locale}
          to={getEquivalentPath(location.pathname, locale, location.hash)}
          lang={locale === 'de' ? 'de-CH' : 'en'}
          aria-label={`Switch to ${localeNames[locale]}`}
          aria-current={locale === currentLocale ? 'true' : undefined}
          onClick={() => {
            persistLocale(locale);
            onNavigate?.();
          }}
        >
          {localeLabels[locale]}
        </Link>
      ))}
    </div>
  );
}
